export const getAllKeys = (data) => {
  let keys = [];
  const extractKeys = (items) => {
    items.forEach((item) => {
      keys.push(item.key);
      if (item.children && item.children.length > 0) {
        extractKeys(item.children);
      }
    });
  };
  extractKeys(data);
  return keys;
};
